import React, { useEffect, useState } from 'react';
import Head from 'next/head';
import Link from 'next/link';
import { useRouter } from 'next/router';
import TagManager from 'react-gtm-module';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../../store/actions';

import { SpinnerV, SnackBar, Breadcrumbs } from 'components/widgets';

import ProfileAllyNav from 'components/navigation/profile/ProfileAllyNav';
import TableAfiliation from 'components/profile/ally/tables-components/TableAfiliations';
import SearchComponent from 'components/profile/ally/tables-components/SearchComponent';
import ModalBenefitsList from 'components/profile/ally/tables-components/ModalBenefitsList';
import {protectRoute} from "../../../src/components/utils/protectRoute"

const AffiliationsPage = (props) => {
	const router = useRouter();

	const { actions } = props;
	const [spinnerScreen, showSpinnerScreen] = useState(false);
	const [openAlert, setOpenALert] = useState(false);
	const [messageAlert, setMessageAlert] = useState('');
	const [search, setSearch] = useState([]);
	const [openModal, setOpenModal] = useState(false);
	const [benefitsList, setList] = useState([]);
	const [routes] = useState([
		{
			name: 'Recomendaciones',
			pathname: router?.pathname,
			asPath: router?.asPath
		},
		{
			name: 'Afiliaciones',
			pathname: router?.pathname,
			asPath: router?.asPath
		}
	]);

	const handleClose = () => setOpenALert(false);

	const handleCloseModal = () => setOpenModal(false);

	const getAfiliations = async (date) => {
		showSpinnerScreen(true);
		const response = await actions.getMyAfiliations(date);
		setSearch(response.data);
		showSpinnerScreen(false);
	};

	const showBenefitsList = (customers) => {
		if (customers && customers.length > 0) {
			setList(customers);
			setOpenModal(true);
		}
	};

	const showMoreInformation = async (id) => {
		router
			.push(
				{
					pathname: '/admin/subscriptions/viewRegistry',
					query: { id: id, fromProfile: true }
				},
				'/admin/ver-registro'
			)
			.then(() => window.scrollTo(0, 0));
	};

	const goToCreateAffiliation = () => {
		props.actions.setMembershipOrigin('ally');
		router.push(
			{
				pathname: '/admin/subscriptions/newAffiliation',
				query: { profileAlly: true }
			},
			'/nueva-afiliacion'
		);
	};

	useEffect(() => {
		const tagManagerArgs = {
			dataLayer: {
				event: 'pageview',
				pageTitle:
					'Afiliaciones | asistensi | Seguro de emergencias medicas y atención médica inmediata'
			}
		};
		TagManager.dataLayer(tagManagerArgs);

		const { token, userType } = props;
		protectRoute({
			router: router,
			token,
			type: userType,
			isAllyRoute: true
		})
		getAfiliations();
	}, []);

	const { isAllyMaster, isAllyMatrix, isAlly, is_promoter } = props;

	return (
		<ProfileAllyNav
			{...props}
			isAllyMaster={isAllyMaster}
			isAllyMatrix={isAllyMatrix}
		>
			<div className="bg-gray-100 w-full py-24 sm:pt-14">
				<Head>
					<title>
						Afiliaciones | asistensi | Seguro de emergencias medicas y atención
						médica inmediata
					</title>
				</Head>
				{spinnerScreen === true && <SpinnerV />}
				<div className="w-full">
					<div className="flex flex-col w-full">
						<div className="flex justify-between flex-wrap flex-col sm:items-center sm:flex-row">
							<div className="flex justify-between mb-8 w-full flex-wrap">
								<div className="w-auto flex flex-col">
									<h1 className="font-poppins text-3xl text-purple-500 font-bold">
										Afiliaciones
									</h1>
									<Breadcrumbs routes={routes} is_profile={true} />
								</div>
								{/* {!is_promoter && (
									<div className="flex justify-between flex-wrap">
										<button
											className="primary-button min-w-full my-2 sm:min-w-0 sm:mr-4"
											onClick={() => goToCreateAffiliation()}
										>
											Afiliación completa
										</button>

										<a
											href="https://forms.zohopublic.com/asistensi/form/PosiblesClientesAliados/formperma/qfPcC0tgwHIPdLDH4In-wne3ci_9qBqoadRPS1wUKcU"
											target="_blank"
											rel="norefferer"
											className="secondary-button min-w-full my-2 sm:min-w-0"
											>
												Invitación rapida
											</a>

										<Link
											href="/ally/inviteClient"
											as="/aliados/invitar-cliente"
										>
											<button
												className="secondary-button min-w-full my-2 sm:min-w-0"
												onClick={() =>
													props.actions.setMembershipOrigin('quick-ally')
												}
											>
												Invitación rapida
											</button>
										</Link>
									</div>
								)} */}
							</div>
							{/* {!is_promoter && (
								<div className="w-full flex justify-center mb-8">
									<Link
										href="/profile/ally/quotation"
										as="/perfil/aliado/cotizar"
									>
										<button className="primary-button-outline uppercase min-w-full sm:min-w-0">
											Generar Cotización
										</button>
									</Link>
								</div>
							)} */}
						</div>

						<div className="w-full">
							<SearchComponent getData={getAfiliations} tabAfiliations={true} />
							<div className="bg-white p-5 border border-gray-300 mt-8">
								<TableAfiliation
									resultSearch={search}
									isAlly={isAlly}
									isAllyMaster={isAllyMaster}
									isAllyMatrix={isAllyMatrix}
									is_promoter={is_promoter}
									showBenefitsList={showBenefitsList}
									showMoreInformation={showMoreInformation}
								/>
							</div>
							{openModal === true && benefitsList.length > 0 && (
								<ModalBenefitsList
									open={openModal}
									customers={benefitsList}
									showMoreInformation={showMoreInformation}
									handleClose={handleCloseModal}
								/>
							)}
						</div>
					</div>
				</div>
				<SnackBar
					openAlert={openAlert}
					messageAlert={messageAlert}
					handleClose={handleClose}
				/>
			</div>
		</ProfileAllyNav>
	);
};

const mapStateToProps = (state) => {
	// affiliation
	const token = state.affiliation.get('token');
	const user_type = state.affiliation.get('user_type');
	const titular = state.affiliation.get('titular');

	const isAllyMatrix =
		state.login.get('id_user') && parseInt(state.login.get('type')) === 111;
	const isAllyMaster =
		state.login.get('id_user') && parseInt(state.login.get('type')) === 110;
	const isAlly =
		state.login.get('id_user') && parseInt(state.login.get('type')) === 100;
	const no_aply_commission = state.login.get('no_aply_commission');
	const is_promoter = state.login.get('is_promoter');
	const userType = parseInt(state.login.get("type"));

	return {
		token,
		user_type,
		titular,
		isAllyMatrix,
		isAllyMaster,
		isAlly,
		no_aply_commission,
		is_promoter,
		userType
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		actions: bindActionCreators(actions, dispatch)
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(AffiliationsPage);
